import ComponentModule from "@eisinc/Overrides/Components/ProductContextAvailability";

export * from "@eisinc/Overrides/Components/ProductContextAvailability";

export default ComponentModule;
